var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrame2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 36,
    viewBox: "0 0 72 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_101_791)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 25.3109L2.30556 25.232C4.61111 25.1531 9.22222 24.9954 13.8333 19.0428C18.4444 13.0902 23.0556 1.34273 27.6667 0.111269C32.2778 -1.12019 36.8889 8.16437 41.5 13.4194C46.1111 18.6745 50.7222 19.9 55.3333 17.3671C59.9444 14.8342 64.5556 8.5428 69.1667 11.5219C73.7778 14.501 78.3889 26.7505 80.6944 32.8752L83 39",
    stroke: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_101_791"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame2);
export default __webpack_public_path__ + "static/media/frame2.150801d7f618d9ff29d164d6f717a96c.svg";
export { ForwardRef as ReactComponent };